// Modules
import { useFormContext } from "react-hook-form"

// Constants
import { ERROR_MESSAGES } from "~constants/errorMessages"

// Components
import MarkdownEditor from "~app/MarkdownEditor"
import { WizardStepContainer, WizardRow, WizardColumn } from "~styled/wizard"

interface StepProps {
  visible?: boolean
}

const CompanyModalStep3 = ({ visible = true }: StepProps) => {
  const { formState: { errors }, register, setValue, getValues, unregister } = useFormContext()

  return (
    <WizardStepContainer className={visible ? "visible" : ""}>
      <WizardRow style={{ marginBottom: 30 }}>
        <WizardColumn>
          <MarkdownEditor
            name="about"
            label="About"
            errorMessage={errors.about && ERROR_MESSAGES.FIELD_REQUIRED}
            required={true}
            {...{ register, setValue, getValues, unregister }}
          />
        </WizardColumn>
      </WizardRow>
    </WizardStepContainer>
  )
}

export default CompanyModalStep3
